var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panel",
    {
      attrs: { popout: "", expand: "" },
      model: {
        value: _vm.settingsPanel,
        callback: function($$v) {
          _vm.settingsPanel = $$v
        },
        expression: "settingsPanel"
      }
    },
    [
      _c(
        "v-expansion-panel-content",
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", { staticClass: "headline" }, [_vm._v("Cinema Settings")])
          ]),
          _vm._v(" "),
          _c("v-card", [_c("v-card-text", [_c("c-business-rules")], 1)], 1)
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2832e562", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2832e562","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Settings.vue
// module id = null
// module chunks = 